import React, { Suspense, useEffect } from "react";
import { lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom";
// import Spinner from "react-bootstrap/Spinner";
import { ThemeProvider } from "../context/ThemeProvider";
import { useSelector } from "react-redux";
import { getRole } from "../_store/_reducers/auth";
import { APP_ROLES } from "./../_helper";
import GuestBadge from "../pages/badgedesign/GuestBadge";
import Loader from "../Loader/Loader";
import { alertAudio, successAudio } from "../assets/sounds";

const Login = lazy(() => import("../pages/login"));
const Register = lazy(() => import("../pages/register"));
const User = lazy(() => import("../pages/register/createuser"));
const Dashboard = lazy(() => import("../pages/dashboard"));
const Admin = lazy(() => import("../pages/superadmin/adminlogin"));
const AdminDashboard = lazy(() => import("../pages/superadmin"));
const ForgotPassword = lazy(() => import("../pages/forgotpassword"));
const BadgeDesign = lazy(() => import("../pages/badgedesign"));
const OrdersPage = lazy(() => import("../pages/orders"));
const AuthLayout = lazy(() => import("./../components/AuthLayout"));
const MainLayout = lazy(() => import("./../components/MainLayout"));
const Camera = lazy(() => import("./../pages/camera"));
const KioskMode = lazy(() => import("./../pages/kiosMode"));
const KioskModeSetting = lazy(() => import("./../pages/kiosMode/Setting"));

const KioskGuard = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const checkKiosk = () => {
      const isKioskLocked = localStorage.getItem('isKioskLocked') === 'true';
      const currentPath = window.location.pathname;
      if (isKioskLocked && currentPath !== '/dashboard/kiosk-mode') {
        navigate('/dashboard/kiosk-mode', { replace: true });
      }else if (!isKioskLocked && currentPath == "/dashboard/kiosk-mode"){
        navigate('/dashboard', { replace: true });
      }
    };
    checkKiosk();
    // Also listen for storage changes in case of multi-tab (though unlikely for kiosk)
    window.addEventListener('storage', checkKiosk);
    return () => window.removeEventListener('storage', checkKiosk);
  }, [navigate]);
  return null;
};

const AppRouter = () => {
  const role = useSelector(getRole);
  // Unlock audio once on first user gesture
    useEffect(() => {
  const unlockAudio = async () => {
    console.log("Unlocking audio on user gesture");

    try {
      // Method 1: Set muted property
      alertAudio.muted = true;
      successAudio.muted = true;

      // Method 2: Set volume to 0
      alertAudio.volume = 0.0;
      successAudio.volume = 0.0;

      // Play with multiple safety measures
      const alertPromise = alertAudio.play()
        .then(() => {
          setTimeout(() => {
            alertAudio.pause();
            alertAudio.currentTime = 0;
            alertAudio.muted = false; // Unmute for future use
          }, 50); // Small delay to ensure play starts
        })
        .catch(() => {});

      const successPromise = successAudio.play()
        .then(() => {
          setTimeout(() => {
            successAudio.pause();
            successAudio.currentTime = 0;
            successAudio.muted = false; // Unmute for future use
          }, 50); // Small delay to ensure play starts
        })
        .catch(() => {});

      await Promise.all([alertPromise, successPromise]);
      
      console.log("Audio unlocked silently with multiple safety measures");
    } catch (e) {
      console.warn("Audio unlock failed", e);
    }

    document.body.removeEventListener("click", unlockAudio);
    document.body.removeEventListener("touchstart", unlockAudio);
  };

  document.body.addEventListener("click", unlockAudio);
  document.body.addEventListener("touchstart", unlockAudio);

  return () => {
    document.body.removeEventListener("click", unlockAudio);
    document.body.removeEventListener("touchstart", unlockAudio);
  };
}, []);
  const handleUserInteraction = () => {
  //   console.log("Play")
  // // Unlocking audio by playing silent buffer or actual audio
  // alertAudio.volume = 0.00; // Very low or mute
  // alertAudio.play().catch(() => {});
  // successAudio.volume = 0.00; // Very low or mute
  // successAudio.play().catch(() => {});

  // Navigate to camera route
};
  return (
    <ThemeProvider>
      <BrowserRouter>
        <KioskGuard />
        <Suspense
          fallback={<Loader />}
        >
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/createuser" element={<User />} />
              <Route path="/adminlogin" element={<Admin />} />
              <Route path="/forgot" element={<ForgotPassword />} />
            </Route>
            {/* AuthLayout for role-based routes */}
            <Route path={"dashboard"} element={<AuthLayout role={role} />}>
              {role === APP_ROLES.ADMIN && (
                <Route index element={<AdminDashboard />} />
              )}
              {role === APP_ROLES.USER && (
                <>
                  <Route index element={<Dashboard  audiohandler={handleUserInteraction}/>} />
                  <Route path={`orders-list`} element={<OrdersPage />} />
                  <Route path={`badge-design`} element={<BadgeDesign />} />
                  <Route path={`guest-badge`} element={<GuestBadge/>}/>
                  <Route path={`cam`} element={<Camera audiohandler={handleUserInteraction} />} />
                  <Route path={`kiosk-mode`} element={<KioskMode audiohandler={handleUserInteraction} />} />
                  <Route path={`kiosk-mode-setting`} element={<KioskModeSetting audiohandler={handleUserInteraction} />} />
                </>
              )}
            </Route>
            <Route path="*" element={<Navigate to={"/"}/>}/>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default AppRouter;
